import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { MenuItem } from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckRounded';
import CustomMenu from '../../../../Components/CustomMenu';

const ScopesMenu = function ScopesMenu({
  anchor = null,
  onClose = () => {},
  outcomes = [],
  defaultSelected = [],
}) {
  const intl = useIntl();
  const [selected, setSelected] = useState(defaultSelected);

  const handleChangeSelected = (value) => () => {
    const copyItems = [...selected];
    const index = copyItems.findIndex(
      ({ outcomeId }) => outcomeId === value?.id
    );

    if (index !== -1) {
      copyItems.splice(index, 1);
    } else
      copyItems.push({
        ...value,
        outcomeId: value?.id,
        outcomeName: value?.name,
      });

    setSelected(copyItems);
  };

  return (
    <CustomMenu
      open={Boolean(anchor)}
      anchor={anchor}
      close={onClose(selected)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <div
        style={{
          padding: '0px 8px',
          minWidth: '16vw',
        }}
      >
        {outcomes.map((outcome) => {
          const isSelected = selected.find(
            ({ outcomeId }) => outcomeId === outcome?.id
          );
          return (
            <MenuItem
              key={outcome?.id}
              disableGutters
              sx={{
                display: 'flex',
                pr: '2px',
                pl: '8px',
                justifyContent: 'space-between',
                borderRadius: '5px',
                color: isSelected && 'primary.main',
                '&.Mui-selected': {
                  background: 'white.main',
                  fontWeight: 'bold',
                },
              }}
              selected={isSelected}
              onClick={handleChangeSelected(outcome)}
            >
              {intl.messages[outcome?.name?.toUpperCase() || 'UNAVAILABLE']}
              {isSelected && <CheckIcon />}
            </MenuItem>
          );
        })}
      </div>
    </CustomMenu>
  );
};

ScopesMenu.propTypes = {
  anchor: PropTypes.object,
  onClose: PropTypes.func,
  outcomes: PropTypes.array,
  defaultSelected: PropTypes.array,
};

export default ScopesMenu;
